export function FormatTokensForDisplay(tokens = 0, precision = 10000.0, decimalPoints = 4): number {
    return Number((tokens / precision).toFixed(decimalPoints));
}
